import { transitionTravelInsuranceQuoteForm } from '../../../actions/travelUg/quote';
import { getQuoteForm } from '../../../selectors/travelUg/quote';
import { FIELD_STATUS } from '../../../reducers/status';

export const quoteFormRules = (store, next, action) => {
    const result = next(action);
    const quoteForm = getQuoteForm(store.getState());
    const quoteFormValid = validateQuoteForm(quoteForm);
    const formAction = quoteFormValid
        ? transitionTravelInsuranceQuoteForm.formValid()
        : transitionTravelInsuranceQuoteForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateQuoteForm = (formFields) => {
    return (
        formFields?.firstName?.status === FIELD_STATUS.VALID &&
        formFields?.lastName?.status === FIELD_STATUS.VALID &&
        formFields?.email?.status === FIELD_STATUS.VALID &&
        formFields?.email?.status === FIELD_STATUS.VALID &&
        formFields?.phoneNumber?.status === FIELD_STATUS.VALID &&
        formFields?.phoneNumber?.status === FIELD_STATUS.VALID &&
        formFields?.tripType?.status === FIELD_STATUS.VALID &&
        formFields?.coverFor?.status === FIELD_STATUS.VALID &&
        formFields?.departureCountry?.status === FIELD_STATUS.VALID &&
        formFields?.destinationCountry?.status === FIELD_STATUS.VALID &&
        formFields?.departureDate?.status === FIELD_STATUS.VALID &&
        formFields?.returnDate?.status === FIELD_STATUS.VALID
    );
};
